<script>
    import { page } from '$app/stores';

    export let items = [];
    export let breadcrumbs = [];

    // Convert the URL path into an array of breadcrumb objects.
    $: pathSegments = $page.url.pathname.split('/').filter(Boolean);

    const build_path_breadcrumbs = (segments, item_list) => [
        { title: 'Home', url: '/' },
        ...segments.map((segment, index) => ({
            title: item_list.find((i) => i.path === segment)?.title || segment
                .replace(/[^a-zA-Z0-9 ]/g, ' ')
                .replace(/\b\w/g, (l) => l.toUpperCase())
                .trim(),
            url: '/' + segments.slice(0, index + 1).join('/')
        }))
    ];

    const normalize_custom_breadcrumbs = (crumbs) => {
        if (!Array.isArray(crumbs)) return [];

        return crumbs.filter((crumb) => {
            return (
                crumb &&
                typeof crumb.title === 'string' &&
                typeof crumb.url === 'string' &&
                crumb.title.trim() &&
                crumb.url.trim()
            );
        });
    };

    const prepend_home = (crumbs) => {
        if (!crumbs.length) return [{ title: 'Home', url: '/' }];

        const first = crumbs[0];
        if (
            first.url === '/' ||
            first.title.trim().toLowerCase() === 'home'
        ) {
            return crumbs;
        }

        return [{ title: 'Home', url: '/' }, ...crumbs];
    };

    $: custom_breadcrumbs = normalize_custom_breadcrumbs(breadcrumbs);
    $: full_breadcrumbs =
        custom_breadcrumbs.length > 0
            ? prepend_home(custom_breadcrumbs)
            : build_path_breadcrumbs(pathSegments, items);
</script>

<nav
    aria-label="breadcrumb"
    class="container mx-auto px-4 md:px-8 mb-4 sm:mb-8"
>
    <ol
        class="flex gap-2 flex-nowrap w-full min-w-0"
        itemscope
        itemtype="https://schema.org/BreadcrumbList"
    >
        {#each full_breadcrumbs as crumb, index (index)}
            <li
                class="flex items-center gap-2 min-w-[5ch] text-center whitespace-nowrap"
                itemprop="itemListElement"
                itemscope
                itemtype="https://schema.org/ListItem"
            >
                <a
                    class="link block w-full"
                    href={crumb.url}
                    itemprop="item"
                >
                    <span itemprop="name" class="block w-full truncate"
                        >{crumb.title}</span
                    >
                </a>
                <meta itemprop="position" content={index + 1 + ''} />
                {#if index !== full_breadcrumbs.length - 1}
                    <span class="opacity-50 shrink-0">\</span>
                {/if}
            </li>
        {/each}
    </ol>
</nav>
